<script>
    import { createEventDispatcher, onMount, afterUpdate, tick, beforeUpdate } from 'svelte';
    import ButtonLoader from "../../utils/button_loader.html"
    import api_handleApiCalls from "../../utils/apiCallHandler.js";
    import print from "print-js";
    export let selectedBatchIdArr =[]
    export let paymentList =[]
    export let studentId
    export let onModalClose;
    export let totalPaid;
    export let balance;
    export let totalAgreedFees
    export let localUserData
    // export let studentBatchInfo


    let receiptModal;
    let todaysDate
    let currentYear
    let newYear
    let orgDetails ={
        name:" - ",
        mobileNo:" - ",
        logo:"",
        headOffice:" - ",
        website:" - ",
        GSTN:" - ",
        orgCode :" - "
    }
    let installmentAmount;
    let installmentDate;
    let StudentsData
    let studentName, mobileNo
    let total = 0
    let InstallmentDetails;

    function setOrganizationData() {
        orgDetails.name = localUserData.orgName
        orgDetails.mobileNo = localUserData.mobileNo
        orgDetails.orgCode = localUserData.orgCode
        if(orgDetails.orgCode == "DFCDFC"){
            orgDetails.headOffice ="Opp. Ludhiana Cycle, Roxy Corner, Paithan Gate Road , Aurangabad."
            orgDetails.website ="www.dfc.org.in"
            orgDetails.mobileNo ="9225318727"
            orgDetails.GSTN ="27ALEPK4847Q1ZE"
            orgDetails.logo = "https://content3.jdmagicbox.com/comp/aurangabad-maharashtra/r2/9999px240.x240.131125145526.e8r2/catalogue/dnyandeep-foundation-center-dfc-paithan-gate-aurangabad-maharashtra-tutorials-2zfe4.jpg"

        }
        else if(orgDetails.orgCode == "pforg"){
            orgDetails.logo  = "data:image/png;base64,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"

        }
        else{
            orgDetails.logo  = ""
            orgDetails.GSTN = '28ALEPS4847Q2AE'
        }
    }
    async function api_getStudentById(studentId) {

        let action = "students.getStuentById";
        var response = await api_handleApiCalls(action, { _id: studentId });
        return response.data

    }

    onMount(async () => {
    //   console.log("selected batch id arr",selectedBatchIdArr)
    //   console.log("studentId ",studentId)
    setOrganizationData()
    StudentsData = await api_getStudentById(studentId);
        // BatchesData = await api_getBatchById(batchId);
        // InstallmentDetails = await api_getNextInstallmentDataByBatchId(batchId, studentId);

        studentName = StudentsData.name;
        //  installmentAmount = InstallmentDetails ? InstallmentDetails.installmentAmount ? convertToINR(InstallmentDetails.installmentAmount) : '-' : "-";
        mobileNo = StudentsData.mobileNo;
        // actualBatchFee = BatchesData.actualBatchFee;
        // payableAmt = convertToINR(BatchesData.amount);
        // enrollmentNo = StudentsData.enrollmentNo;
        todaysDate = moment(new Date()).format("DD-MM-YYYY")
        currentYear = new Date().getFullYear()
        newYear = new Date().getFullYear() + 1

        // receiptNo = studentBatchInfo.seqId;
        // batchName = BatchesData.name;
    console.log("paymentList",paymentList)
    await tick();
        var scroll1
      _$(receiptModal).modal("show");
      _$(receiptModal).on('shown.bs.modal', function () {
            scroll1 = new PerfectScrollbar('#scroll1', {
                suppressScrollX: true
            });
        });
        _$(receiptModal).on('hidden.bs.modal', function () {
            onModalClose()
        });
    })
    async function api_getNextInstallmentDataByBatchId(batchId, studentId) {

let action = "payment.getNextInstallmentDataByBatchId";
var response = await api_handleApiCalls(action, { batchId: batchId, studentId: studentId });
return response.data;

}
    let convertToINR = function (input) {
        let amount = Number(input);
        return amount.toLocaleString('en-IN', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            style: 'currency',
            currency: 'INR'
        });
    }
    function convertDateObjToStr(date) {
        date = new Date(date);
        var month = "" + (date.getMonth() + 1);
        var day = "" + date.getDate();
        var year = date.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        var dateString = [day, month, year].join("-");
        return dateString;
    }

    let printReceipt = () => {
        _$('.page').css({ 'transform': 'scale(1)' });
        _$('#print-container').css({ 'padding-top': '0' });
        print({
            printable: 'print-container',
            type: 'html',
            header: false,
            scanStyles: false,
            scanStyles: false,
            style: `html, body {
                    padding : 0;
                    margin : 0;
                }
                 * {
                        box-sizing: border-box;
                        -moz-box-sizing: border-box;
                    }
                `,
            onPrintDialogClose: function () {
                _$('.page').css({ 'transform': 'scale(' + (window.innerHeight - 150) / (1122 / 2) + ')' });
                _$('#print-container').css({ 'padding-top': '15px' });
            }
        })
    }
    afterUpdate(() => {
        // ...the DOM is now in sync with the data
        function calculateTotal() {

        }
    });
    let getPaymentDesc = function (paymentObj) {
        let message = "Unpaid";
        if (paymentObj.isRefunded) {
            message = "Refund";
        } else {
            if (paymentObj.paidAmount && paymentObj.paidAmount == paymentObj.installmentAmount) {
                message = "Paid";
            }
            if (paymentObj.paidAmount && paymentObj.paidAmount != paymentObj.installmentAmount) {
                message = "Partial Paid";
            }
        }
        return message;




    }
    let getPaymentType = function (value) {
        let paymentTypeOptions = {
            cash: "Cash",
            cheque: "Cheque",
            dd: "DD",
            onlinePay: "Online Payment",
            upi: "UPI",
            card: "Card Payment",
        }
        return paymentTypeOptions[value];

    }
    function convertNumberToWords(amount) {
    var words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    
    amount = amount.toString();
    var atemp = amount.split(".");

    var number = atemp[0].split(",").join("");

    var n_length = number.length;

    var words_string = "";
    if (n_length <= 9) {
        var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        
        var received_n_array = new Array();

        for (var i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);


        }
        for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];

        }
        for (var i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i == 7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + parseInt(n_array[j]);
                    n_array[i] = 0;
                }
            }
        }
      let  value = "";
        for (var i = 0; i < 9; i++) {
            if (i == 0 || i == 2 || i == 4 || i == 7) {
                value = n_array[i] * 10;
            } else {
                value = n_array[i];
            }
            if (value != 0) {
                words_string += words[value] + " ";
            }
            if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Crores ";
            }
            if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Lakhs ";
            }
            if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Thousand ";
            }
            if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
                words_string += "Hundred and ";
            } else if (i == 6 && value != 0) {
                words_string += "Hundred ";
            }
        }
        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
}
</script>

<div class="modal fade" bind:this={receiptModal}   tabindex="-1" role="dialog" aria-labelledby="receipt-modal-label"
    style="display: none ;height: 100%; overflow: auto;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content tx-14">
            <div class="modal-header">
                <h6 class="modal-title" id="receipt-modal-label">Receipt</h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body" style="display: flex;height: 100%;flex-direction: column; overflow: auto;">
                <div id="print-container" style="    
                                flex: 1;
                                overflow: auto;
                                display: flex;
                                overflow-y: auto;
                                overflow-x: hidden;
                                justify-content: center;
                                background:#ddd;
                            ">

                    <style>
                        * {
                            box-sizing: border-box;
                            -moz-box-sizing: border-box;
                        }

                        .print-receipt-tbl {
                            border-spacing: 0;
                            /* border-color: gray; */
                            /* border : 1px solid black; */
                        }

                        /* .table {
                        margin-top: 80px;
                        border: 1px solid black;
                    } */

                        .th,
                        .td {
                            border: 1px solid black;
                        }

                        .print-receipt-tbl td {
                            padding: 2px 5px;
                            /* border : 1px solid black; */
                        }

                        .page {
                            width: 22cm;
                            min-height: 200mm;
                            padding: 0;
                            margin: 0 10pt;
                            border: 1px #D3D3D3 solid;
                            border-radius: 5px;
                            background: white;
                            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
                            background-size: contain;
                            background-repeat: no-repeat;
                            transform-origin: top center;
                            display: flex;
                            flex-direction: column;
                            overflow: hidden;
                        }

                        .p-body {
                            flex: 1;
                            display: flex;
                            background-repeat: no-repeat;
                            background-position: center;
                            width: 20cm;
                        }

                        /* .p-body-center {
                            flex: 1;
                            display: flex;
                            flex-direction: column;
                        } */

                        .p-body-divName {
                            flex: 1;
                            display: flex;
                            flex-direction: row;
                        }

                        .p-body-divTable {
                            flex: 2;
                            display: flex;
                            flex-direction: row;
                        }

                        .p-header,
                        .p-footer {
                            background-repeat: no-repeat;
                            background-size: contain;
                            width: 21cm;
                        }

                        .p-body-left,
                        .p-body-right {
                            background-repeat: no-repeat;
                            background-size: contain;
                        }

                        @page {
                            size: A4;
                            margin: 0;
                        }

                        @media print {
                            .page {
                                margin: 0;
                                border-radius: initial;
                                width: initial;
                                min-height: initial;
                                page-break-after: always;
                            }
                        }
                    </style>

                    <div class="book">
                        <div class="page">
                            <table style="border: 1px solid black; border-collapse: collapse; margin: 10px;"
                                class="h-10">
                                <tbody>
                                    <tr>
                                        <td rowspan="2" style="width:20%; text-align: center; border: 1px solid black;">
                                            {#if orgDetails.logo  !=""}
                                            <img src={orgDetails.logo } style="height:100px; width:100px"/>
                                            {/if}
                                        </td>

                                        <td style="  border: 1px solid black;padding:10px">
                                            <h4 style=""><b>{orgDetails.name.toUpperCase() }</b></h4>
                                            <label>HeadOffice :{orgDetails.headOffice } </label>
                                            <br>
                                            <label style="">Website : {orgDetails.website } </label>
                                        </td>


                                    </tr>
                                    <tr>
                                        <td style=" text-align: center; border: 1px solid black; padding:10px">
                                            <label style="float: left;">Helpline : {orgDetails.mobileNo }</label>

                                            <label style="float: right; ">GSTN :{orgDetails.GSTN } </label>
                                        </td>

                                    </tr>

                                </tbody>
                            </table>
                            <div class="p-header">
                                <h4 style="text-align: center; margin-top: 10px;">
                                    Receipt
                                </h4>
                            </div>

                            <div style="width: 100%; display: inline;">


                                <label class="" style="float: left; margin-left: 10px;"><b>Receipt No.:</b> </label>
                                <label style="float: right;margin-right: 10px; "><b>Date:</b> {todaysDate}</label>

                            </div>
                            <div class="p-body" style="margin:10px ;width: 100%; ">
                                <p>Received with thanks from <u> {studentName} </u> the Sum of total
                                    fees (in words) Rupees. <u> {totalPaid ? convertNumberToWords(totalPaid):  "         "} </u> only. <br> 
                                    <!-- <b>Details of Cheque: </b> Bank:__________________ -->

                                </p>


                            </div>

                            <table style=" margin: 10px;">
                                <td style=" text-align: left"><b>Total Agreed Fees :</b>
                                    {convertToINR(totalAgreedFees) ?
                                    convertToINR(totalAgreedFees) : convertToINR(0)}</td>
                                <td style=" text-align: center"><b>Total Paid Fees :</b> {convertToINR(totalPaid) ?
                                    convertToINR(totalPaid) :
                                    convertToINR(0)}</td>
                                <td style=" text-align: right"><b>Total Balance Fees :</b> {convertToINR(balance) ?
                                    convertToINR(balance) :convertToINR(0)}
                                </td>
                            </table>

                            <table style="border: 1px solid black; border-collapse: collapse; margin: 10px;">
                                <thead>
                                    <tr>
                                        <th style="width: 5%; text-align: center; border: 1px solid black;">Sr. No.</th>
                                        <th style="width: 20%; text-align: center; border: 1px solid black;">Batch</th>

                                        <th style="text-align: center; border: 1px solid black;">Date</th>
                                        <th style="text-align: center; border: 1px solid black;">Type</th>

                                        <th style="text-align: center; border: 1px solid black;">Cheque No</th>
                                        <th style="text-align: center; border: 1px solid black;">Status</th>

                                        <th style="width: 20%; text-align: center; border: 1px solid black;">Amount(Rs.)
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {#each paymentList as aPayment, index }
                                    <tr>
                                        <td style="border: 1px solid black; text-align: center">{index + 1}</td>
                                        <td style="border: 1px solid black; text-align: center">{aPayment.batchName ? aPayment.batchName + " ( " + aPayment.className + " ) " : ""}
                                        
                                        </td>

                                        <td style="border: 1px solid black; padding-left:10px ;text-align: center">
                                            {aPayment.paymentDate ? moment(aPayment.paymentDate).format("DD-MM-YYYY"): " - "}</td>
                                        
                                        <td
                                            style="border: 1px solid black; padding-left:10px;width: 150px; overflow-wrap: anywhere;text-align: center">
                                            {aPayment.paymentType == "cheque" ? getPaymentType(aPayment.paymentType) + " from "+ " " + aPayment.bankName + " Bank":getPaymentType(aPayment.paymentType) }</td>
                                            <td style="border: 1px solid black; padding-left:10px ;text-align: center">
                                                {aPayment.paymentType == "cheque" ? aPayment.chequeNo : " - "}</td>
                                        <td style="border: 1px solid black; padding-left:10px;text-align: center">
                                            {getPaymentDesc(aPayment)}</td>

                                        <td style="border: 1px solid black; text-align: center;">
                                            {aPayment.isRefunded ? convertToINR(aPayment.paidAmount ): aPayment.installmentAmount ? convertToINR(aPayment.installmentAmount): convertToINR(0) }/-
                           
                                        </td>
                                    </tr>
                                    {/each}
                                  

                                </tbody>
                                <tfoot>
                                    <tr style="padding-top: 10px; margin-top: 10px;">
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td style="text-align: end; margin-right: 10px; padding-right: 20px;">Total</td>
                                        <td style='text-align: center'>{totalPaid? convertToINR(totalPaid):convertToINR(0)}/- </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <div class="p-body" style="margin:10px">
                                <p>Towards the Part / Full / Advance Tution fees for the course to be conducted for the
                                    year {currentYear + " - " + newYear}</p>
                            </div>
                            <table style=" margin: 10px;">
                                <tr>
                                    <td style=" text-align: left">-------------------------</td>
                                    <td style=" text-align: right">-------------------------</td>
                                </tr>
                                <tr>
                                    <td style=" text-align: left"><b>Student's Signature</b></td>
                                    <td style=" text-align: right"><b>Faculty's Signature</b></td>
                                </tr>
                            </table>
                           
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary tx-13"
                    data-dismiss="modal">Close</button>
                <button type="button" on:click={printReceipt} class="btn btn-primary tx-13">Print</button>
            </div>
        </div>
    </div>
</div>